// Sugalarm — /api/cgm wrappers.

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";

export type CGMProvider = "dexcom" | "libre";

export interface CGMConnectIn {
  provider: CGMProvider;
  username?: string; // Dexcom uses username; Libre uses email — both go here as the login id
  email?: string;
  password: string;
  region?: "US" | "OUS" | string;
}

export interface CGMConnectResult {
  success: boolean;
  provider: CGMProvider;
  message?: string;
  // Cycle 20: number of historical readings pulled on the initial
  // backfill. Optional because older servers won't return it.
  backfill_count?: number;
  // Cycle 234.6: non-fatal warning when the account linked but data won't
  // flow yet (e.g. Libre connected but no sensor shared). `warning` is the
  // human-readable copy to show verbatim; `warning_code` is the machine key.
  warning_code?: string | null;
  warning?: string | null;
}

export interface CGMStatus {
  connected: boolean;
  provider: CGMProvider | null;
  latest_reading?: unknown;
  region?: string | null;
  // Cycle 88: unresolved credential rejection + the non-secret account
  // identifier for prefilling the update form.
  cgm_auth_failed?: boolean;
  username?: string | null;
}

export function connect(body: CGMConnectIn): Promise<ApiResult<CGMConnectResult>> {
  return request<CGMConnectResult>("/api/cgm/connect", { method: "POST", body });
}

export function status(): Promise<ApiResult<CGMStatus>> {
  return request<CGMStatus>("/api/cgm/status");
}

export function disconnect(): Promise<ApiResult<void>> {
  return request<void>("/api/cgm/disconnect", { method: "DELETE" });
}
